module.exports = __webpack_public_path__ + "static/Aneta_2-677caecd660b92ca8998707569e973da.jpg";